import React from 'react'
import '../css/about.css'
import AboutImg from '../assets/package/wildlife3.jpg'

const About = () => {
  return (
    <div className='about-section'>
      <div className="about-left">
        <img src={AboutImg} alt="" />
      </div>
      <div className="about-right">
        <h3>Welcome to <i class="fa-solid fa-paw"></i></h3>
        <h2> MP Holidays Pvt. Ltd.</h2>
        <p>As the name defines itself we MP Holidays Private Limited are eagerly working on customer satisfaction to provide the best in the destination with best services at best rates. Being specialized in the area we work to provide the tourist with personalised services to make them feel special and make their stay a remarkable one. MP being centrally located is accessible from every part of the country and has something to offer to people with diverse age and taste.</p>
      </div>
    </div>
  )
}

export default About
